import React, { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import { ExportViewProps, ExportViewRef } from "./models";
import { searchFilterToExportExcelFilter } from "../../../Common/SearchFilter/utils";
import useDidMountEffect from "../../../Common/UseDidMountEffect";

interface ISearchFilter {
}

const B2BAdmins = forwardRef<ExportViewRef, ExportViewProps>((props, ref) => {
    const [searchFilter, setSearchFilter] = useState({} as ISearchFilter);
    useImperativeHandle(ref, () => ({
        isValid: () => {
            return true;
        }
    }));

    useEffect(() => {
        props.onChange([]);
    },[]);

    const render = () => {
        return (
           <></>
        );
    };

    return render();
});

export default B2BAdmins;
